module.exports = __webpack_public_path__ + "img/img-94.0fedb465.png";